import {
  EyeStroke,
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onGetDataClick?: () => void;
  onViewClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onGetDataClick,
  onViewClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick
}) => (
  <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục cơ quan thuế</h1>}>
    {onAddClick && <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} />}
    {onEditClick && <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isViewDisabled} />}
    {onDeleteClick && (
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isViewDisabled} />
    )}
    {onCopyClick && (
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isViewDisabled} />
    )}
    {onGetDataClick && (
      <ActionButtonV2
        icon={RefreshCircle1ClockwiseStroke}
        title='Lấy dữ liệu mới'
        onClick={onGetDataClick}
        disabled={isViewDisabled}
      />
    )}
    {onViewClick && <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />}

    <MenuButtonV2
      title='Khác'
      items={[
        {
          title: 'Refresh',
          icon: <AritoIcon icon={15} />,
          onClick: onRefreshClick,
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: <AritoIcon icon={16} />,
          onClick: onFixedColumnsClick,
          group: 0
        },
        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={555} />,
          onClick: onExportClick,
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);

export default ActionBar;
